// extracted by css-extract-rspack-plugin
export default {"projectFilterButton":"ListProjectFilter-module__projectFilterButton__PTR36"};